module.exports = __webpack_public_path__ + "img/logo02.b03519ce.svg";